export default __webpack_public_path__ + "static/media/Ved-Shala.a7c03ae3.jpg";